module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Option-070de57f8783b9b94274daa72cdb478a.svg";